module.exports = "<v-container> <v-layout row wrap> <v-flex xs12> <v-text-field label=\"Podaj nazwę grupy\" placeholder=\"Podaj nazwę grupy\" type=text v-model=waterUsageRecipient autofocus v-on:input=\"updateValue('waterUsageRecipient', $event)\"></v-text-field> </v-flex> </v-layout> </v-container> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/viewer/edition/template/templateDialogSaveRecipients.html
// module id = 2178
// module chunks = 0